(function () {
	'use strict';
	var templateUrl = require('./contentTypesConfig.template');

	/**
	 * @ngdoc directive
	 * @name smb-app.smbContentTypesConfig
	 * @module smb-app
	 * @restrict E
	 * 
	 * @description
	 * Displays the configuration section for a list of content types that belong
	 * to a specific content type group.
	 * 
	 * @usage
	 * 
	 * <smb-content-types-config content-type-group-id="11" />
	 * 
	 * @element input
	 * @param {number=} contentTypeGroupId The id of the content type group whose content types are being displayed.
	 */

	angular
		.module('smb-app')
		.directive('smbContentTypesConfig', ContentTypesConfigDirective)
		.controller('ContentTypesConfigController', [
			'$mdDialog',
			'pxAuthService',
			'sbToastService',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbContentTypesDataStore',
			'smbIconTypes',
			'smbDeleteDialogService',
			ContentTypesConfigController
		]);
	
	function ContentTypesConfigDirective() {
		return {
			restrict: 'E',
			controller: ContentTypesConfigController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				contentTypeGroupId: '@'
			}
		};
	}

	function ContentTypesConfigController($mdDialog, pxAuthService, sbToastService, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypesDataStore, smbIconTypes, smbDeleteDialogService) {
		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.deleteDocumentType = deleteDocumentType;

		// TODO: Add group name?
		smbToolbarService.set(gettextCatalog.getString('Document Types Configuration'), 'contentConfig.groups');

		vm.contentTypesDS = smbContentTypesDataStore;

		// TODO: Error handling
		smbContentTypesDataStore.getContentTypes(vm.contentTypeGroupId);

		function deleteDocumentType(event, documentType) {	
			var title = gettextCatalog.getString('Delete Document Type');
			var message = gettextCatalog.getString('Would you like to delete "{{typeName}}"?', { 
				typeName: documentType.FolderName 
			});
			var purgeText = gettextCatalog.getString('Selecting this checkbox will enable permanent deletion of this document type and all related documents that can\'t be undone!');
			
			smbDeleteDialogService
				.show(event, title, message, pxAuthService.isSiteAdmin, purgeText)
				.then(function (purge) {
					pxProgressService.visible = true;
					smbContentTypesDataStore
						.deleteContentType(documentType.FolderId, purge)
						.then(function () {
							var deleteMessage = gettextCatalog.getString('{{typeName}} was deleted!', { 
								typeName: documentType.FolderName 
							});
							sbToastService.showSimple(deleteMessage);
						})
						.catch(function () {
							var deleteIssueMessage = gettextCatalog.getString('Unable to delete group');
							sbToastService.showSimple(deleteIssueMessage);
						})
						.finally(function () {
							pxProgressService.visible = false;
						});
				}, angular.noop());
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypesConfig/contentTypesConfig.js
// module id = 76
// module chunks = 1